<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  computed:{
  get_session:function(){return mapGetters(["Session","AllCategories","Cart","CartCount","FeaturedProucts","AllProducts"])},
  get_cart:function(){return mapGetters(["Cart","CartCount"])},
  get_categories:function(){return mapGetters(["AllCategories"])},
  get_products:function(){return mapGetters(["FeaturedProucts","AllProducts"])}
},
  created(){
    this.getCategories();
    this.getSession();
    this.getProducts();
    this.getFeaturedProducts();
    this.getCart();
},
watch:{
  
  AllCategories(newValue) { this.get_response(newValue)  },
  Session(newValue) { this.get_response(newValue)  },
  Cart(newValue) { this.get_response(newValue)  },
  CartCount(newValue) { this.get_response(newValue)  },
  Products(newValue) { this.get_response(newValue)  },
  FeaturedProducts(newValue) { this.get_response(newValue)  }
  
},
  methods:{
      ...mapActions(['getSession','getCart','getCategories','getProducts','getFeaturedProducts']),
      get_response:function(){

      }
  }
}
</script>
<style>
#app {
  
}

</style>
